export default __webpack_public_path__ + "7d3e808a75cf5951e04143f53647344e.png";